import { FC, useEffect, useRef, useState } from 'react';

import TextField from '@mui/material/TextField';

type DescriptionCustomColumnProps = {
  initialValue: string;
  onChange: (value: string) => void;
};

const DescriptionCustomColumn: FC<DescriptionCustomColumnProps> = ({
  initialValue,
  onChange,
}) => {
  const onChangeRef = useRef(onChange);

  const [description, setDescription] = useState(initialValue || '');

  useEffect(() => onChangeRef.current(description), [description]);

  return (
    <TextField
      fullWidth
      label=''
      placeholder='Prefill with Description'
      variant='standard'
      value={description}
      onChange={(e) => {
        setDescription(e.target.value);
      }}
      onKeyDown={(e) => e.stopPropagation()}
      sx={{
        '& .MuiInputBase-input': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }}
    />
  );
};

export default DescriptionCustomColumn;
